import React from 'react';

// SUNY Buffalo Logo Component - Using authentic logo
export const SUNYBuffaloLogo = ({ className = "w-8 h-8" }) => (
  <div className={`${className} flex-shrink-0 bg-white rounded p-1 flex items-center justify-center`}>
    <img 
      src={`${process.env.PUBLIC_URL}/ub.png`}
      alt="SUNY Buffalo" 
      className="w-full h-full"
      style={{ 
        objectFit: 'contain'
      }}
      onError={(e) => {
        console.error('SUNY Buffalo logo failed to load:', e.target.src);
        e.target.style.display = 'none';
      }}
      onLoad={() => console.log('SUNY Buffalo logo loaded successfully')}
    />
  </div>
);

// Vellore Institute of Technology Logo Component - Using authentic logo
export const VITLogo = ({ className = "w-8 h-8" }) => (
  <div className={`${className} flex-shrink-0 bg-white rounded p-1 flex items-center justify-center`}>
    <img 
      src={`${process.env.PUBLIC_URL}/vit.png`}
      alt="Vellore Institute of Technology" 
      className="w-full h-full"
      style={{ 
        objectFit: 'contain'
      }}
      onError={(e) => {
        console.error('VIT logo failed to load:', e.target.src);
        e.target.style.display = 'none';
      }}
      onLoad={() => console.log('VIT logo loaded successfully')}
    />
  </div>
);
